import { useProgressCards } from "@features/dashboard/hooks/useProgressCards";
import { handleNavigateBack } from "@helpers/common";
import { useAppStore } from "@hooks/useAppStore";
import { isWeb } from "@memorang/helpers/platform";
import Box from "@memorang/ui/components/Box";
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";
import { PracticeTestsCard } from "@memorang/ui/components/ProgressApplet/PracticeTestsCard";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { router } from "expo-router";

const DetailedListPracticeTestsContainer = () => {
	const appFont = useAppStore((state) => state.app.font) || "opensans";
	const { data } = useProgressCards();
	const practiceTests = data.practiceTests;

	if (!practiceTests) {
		return null;
	}

	return (
		<>
			<CustomAppBar
				title={practiceTests.title}
				onPressBack={() => handleNavigateBack("/(protected)/(tabs)/progress")}
				hideCommandBar
			/>
			<Box flex={1}>
				<ScrollContainer
					maxWidth="sm"
					contentContainerStyle={{
						padding: 16,
					}}
				>
					<PracticeTestsCard
						{...practiceTests}
						isWeb={isWeb}
						appFont={appFont}
						handleNavigation={(numericId) =>
							router.push(`/session/${numericId}/report/`)
						}
					/>
				</ScrollContainer>
			</Box>
		</>
	);
};

export default DetailedListPracticeTestsContainer;
